import { checkRatePassphrase } from "@/services/checkout.queries";
import { useToastNotify } from "@/stores/toastStore";
import { useMutation } from "@tanstack/react-query";

export function useRatePassphraseCheck() {
  const { notify } = useToastNotify();
  return useMutation({
    mutationKey: ["rate-passphrase"],
    mutationFn: checkRatePassphrase,
    onError: (error) => {
      console.error("Error checking rate passphrase:", error);
    },
  });
}
